// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"f35fe632cbfd7c39575b","339":"6abe6836b798bb12eac7"}[chunkId] + ".js";
};